import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
// Copyright 2017-2022 @polkadot/api-derive authors & contributors
// SPDX-License-Identifier: Apache-2.0
export function filterBountiesProposals(api, allProposals) {
  var bountyTxBase = api.tx.bounties ? api.tx.bounties : api.tx.treasury;
  var bountyProposalCalls = [bountyTxBase.approveBounty, bountyTxBase.closeBounty, bountyTxBase.proposeCurator, bountyTxBase.unassignCurator];
  return allProposals.filter(function (proposal) {
    return bountyProposalCalls.find(function (bountyCall) {
      return bountyCall.is(proposal.proposal);
    });
  });
}